export class PseAvTransaction {
    constructor(
        public convenioId= '',
        public transaccionConvenioId= '',
        public referenciaPago1= '',
        public descripcion= '',
        public urlRespuesta= '',
        public hash= '',
        public valor= '',

    ) { }
}
